export const FILE_STATUS = {
  NEW: 'NEW',
  PROCESSING: 'PROCESSING',
  DONE: 'DONE',
};

export const menuGroups = {
  TOP: 'TOP',
  MAIN: 'MAIN',
  BOTTOM: 'BOTTOM',
};

export const pageSize = 10;

export const TAB_KEY = 9;
export const ENTER_KEY = 13;
export const ESCAPE_KEY = 27;

export const MESS_CODE = {
  NOT_FOUND: 40400,
  API_NOT_FOUND: 40500,
  DUPLICATE_RECORD: 40600,
  VALIDATION_ERROR: 40202,
  INVALID_PARAMS: 40000,
  FORBIDDEN: 40300,
  AUTH_ERROR: 40100,
  SERVER_ERROR: 50000,
  NETWORK_REFUSED: 'NR001',
  OK: 40200,
};
export const multiLangSupport = [
  {
    code: 'en_US',
    key: 'en',
    icon: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABSklEQVQ4T9WUu0oDQRSG/9lhXZON2QhJVAhIOjsfQcHYbso8gVaCkOQFVCwtLXwOsdNSsPAGIhG0MIUoJiC7G/c2MzsW0U7YWUiTqQb+73xzzimGYMKHTNiHKRBurLbCJJHQtHGz/907Tzf9ShQylfWQht2Vhq7DMHRQSuCOAhQLeXAhEEYMjHGcHG4Pl5cqQkm42fwVzs6MhV4Aa84E5wJBFIMxht2Ls7fFOORqQrsrKdWQyxmglML1vmEVTXAmEIQRhEhwfLDVq9eqsbJQ0/6EBI7rwyoWIASHH8SQSYL2891tLWGhkrBhd6Tj+KiULUhIfA4cLJRLkERiMHRRsvI4aq1d1avzasJ9e+cl7eVm2Xy3dKK2w3577zJNmCUnX6fn91kK0ljysLL+mgZlyQn3Rh9ZCtJYco3aYxqUJZ+C3ybLOCrsxEf+AWwcgB25elzcAAAAAElFTkSuQmCC',
    name: 'English',
  },
  {
    code: 'vi_VN',
    key: 'vi',
    icon: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAA3klEQVQ4T9WUMQ4BQRSGv8ciokAUEo1YHaVDqHSOING4ABfQK7mDSuEIOg06RKEUFAg2RtaW7K5sJhJTz/vm//68jKD5iGYefwCcZMszndoyyZbVz4HhBCgFj7P/018lTNfkRdyPNAHNvg2EVdO/HdeE8RLku2CkhJjpJLuuwDrApq24LD6n9VSO5qA4gETFWdfTFJYNxW3rru7bYaEnZOoOYDeEdctb2xMoESiNhU3HhsirgkVVoe4BExpp4AHW0QEYSSAE1j4g0H9J3m/YyvMgg24zf/Db6NS1WdqVn1BORizMPUNvAAAAAElFTkSuQmCC',
    name: 'Vietnamese',
  },
];

export const alphabet = [
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'V',
  'W',
  'X',
  'Y',
  'Z',
];
